import React, { useState, useEffect } from "react";
import { useQueryClient } from "react-query";
import TableNoBorder from "../../components/tables/TableNoBorder";
import SelectInput from "../../components/SelectInput";
import TextInput from "../../components/TextInput";
import DateInput from "../../components/DateInput";

import TableFilters from "./TableFilters";
import { addFees } from "../../actions/Utilities/Fees";
import SaveButton from "../../components/SaveButton";
import CancelButton from "../../components/CancelButton";
import Swal from "sweetalert2";

import ConfirmBoxModal from "../../components/ConfirmBoxModal";
const AddPolicyFeeForm = ({
  stateOptions,
  carrierOptions,
  Cancel,
  feeLevelOptions,

  feeTypeData,
  policyTermOptions,
}) => {
  const queryClient = useQueryClient();

  const [filter, setFilter] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState([]);

  const [selectedCarrier, setSelectedCarrier] = useState([]);
  const [selectedState, setSelectedState] = useState([]);

  const [selectedFeeLevel, setSelectedFeeLevel] = useState([]);
  const [selectedPolicyTerm, setSelectedPolicyTerm] = useState([]);
  const [inputFeeAmount, setInputFeeAmount] = useState("");

  const [effectiveDate, setEffectiveDate] = useState("");
  const [expirationDate, setExpirationDate] = useState("");
  const [minExpirationDate, setMinExpirationDate] = useState("");

  const [saveModal, setSaveModal] = useState(false);
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });
  const policyTypeFormat = {
    commissionablePremiumId: 0,
    carrierId: 0,
    carrierName: "",
    state: "",
    effectiveDate: null,
    expirationDate: null,
    policyTerm: 0,
    feeType: "",
    feeAmount: 0,
    feeLevel: "",
    createdBy: "",
    createdOn: null,
    updatedBy: "",
    updatedOn: null,
  };

  const [addedPolicyTypeData, setAddedPolicyTypeData] = useState([
    policyTypeFormat,
  ]);

  function getUnique(arr, index) {
    const unique = arr
      .map((e) => e[index])

      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the dead keys & store unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);

    return unique;
  }

  //Validation

  useEffect(() => {
    if (
      selectedCarrier?.value !== null &&
      selectedState?.label !== null &&
      effectiveDate !== "" &&
      addedPolicyTypeData[0]?.feeType !== "" &&
      inputFeeAmount !== "" &&
      selectedFeeLevel?.value !== ""
    )
      setSaveDisabled(false);
    else setSaveDisabled(true);
  });

  //filter content of data to get the unique fee types
  // const updateFeeType = data.map((ftype) => {
  //   return { label: ftype.feeType, value: ftype.feeType }
  //     });
  //   const uniqueFeeTypes = getUnique(updateFeeType,'label');
  //   setFeeTypeOptions(uniqueFeeTypes);

  const handleEdit = (row) => {
    setSelectedPolicyTerm(
      policyTermOptions.filter((item) => item.value === row.policyTerm)
    );
    setSelectedCarrier(
      carrierOptions.filter((item) => item.label === row.carrierName)
    );
    setSelectedState(stateOptions.filter((item) => item.label === row.state));
    setEditMode(true);
    setEffectiveDate(row.effectiveDate.slice(0, 10));
    setExpirationDate(row.expirationDate.slice(0, 10));

    // const editData = data.map((item) => {
    //   if (item.commissionablePremiumId === row.commissionablePremiumId) {
    //     item.editRow = true;
    //   } else {
    //     item.editRow = false;
    //   }
    //   return { ...item };
    // });
    setEditData(editData);
  };

  useEffect(() => {
    setSelectedCarrier({ selectedCarrier });
  }, []);

  const handleSave = (row) => {
    //fields validation
    if (
      selectedCarrier.value !== null &&
      selectedState.label !== null &&
      effectiveDate !== "" &&
      feeTypeData.filter((x) => x.value === addedPolicyTypeData[0].feeType)
        .length > 0 &&
      addedPolicyTypeData[0].feeAmount !== "" &&
      selectedFeeLevel.value !== ""
    ) {
      addedPolicyTypeData[0].effectiveDate = new Date(
        effectiveDate
      ).toISOString();
      // addedPolicyTypeData[0].expirationDate =
      //   expirationDate == "" ? null : new Date(expirationDate).toISOString();
      // addedPolicyTypeData[0].carrierId = selectedCarrier.value;
      // addedPolicyTypeData[0].carrierName = selectedCarrier.label;
      // addedPolicyTypeData[0].state = selectedState.label;
      // addedPolicyTypeData[0].policyTerm = selectedPolicyTerm.value;
      addedPolicyTypeData[0].commissionablePremiumId =
        row.commissionablePremiumId;
      // addedPolicyTypeData[0].feeType = row.feeType;
      // addedPolicyTypeData[0].feeAmount = row.feeAmount;
      // addedPolicyTypeData[0].feeLevel = row.feeLevel;
      addedPolicyTypeData[0].createdBy = localStorage.getItem("userName");
      addedPolicyTypeData[0].createdOn = new Date().toISOString();
      addedPolicyTypeData[0].updatedBy = localStorage.getItem("userName");
      addedPolicyTypeData[0].updatedOn = new Date().toISOString();

      //call add agreement
      addFees(addedPolicyTypeData)
        .then((res) => {
          if (res === "Duplicate") {
            Toast.fire("Failed", "Fees Already Exists", "warning");
            setSaveModal(false);
          } else {
            queryClient.invalidateQueries(["Fees"]);
            queryClient.invalidateQueries(["CarrierOptions"]);
            queryClient.invalidateQueries(["States"]);
            Toast.fire("Success", "Fees Added Successfully", "success");
            Cancel(false);
            // CollapseAll();
          }
        })
        .catch((err) => {
          Toast.fire("Failed", "Failed to Add Fees", "error");
        });
    } else {
      Toast.fire("Saving Failed", "All fields must be filled!", "error");
    }
  };

  const handleEditPolicyType = (SourceType, fieldName, inputvalue) => {
    if (SourceType === "EditPolicyType") {
      if (fieldName === "feeType") {
        addedPolicyTypeData[0].feeType =
          inputvalue.value !== undefined ? inputvalue.value : "";
      }
      if (fieldName === "feeAmount") {
        addedPolicyTypeData[0].feeAmount = inputvalue;
      }
      if (fieldName === "policyTerm") {
        addedPolicyTypeData[0].policyTerm = inputvalue;
      }
      if (fieldName === "feeLevel") {
        addedPolicyTypeData[0].feeLevel = inputvalue;
      }
    }
  };
  const handleAddPolicyType = (fieldName, selectedValue) => {
    if (fieldName === "CarrierName") {
      addedPolicyTypeData[0].carrierName = selectedValue;
    }
    if (fieldName === "CarrierId") {
      addedPolicyTypeData[0].carrierId = selectedValue;
    }
    if (fieldName === "State") {
      addedPolicyTypeData[0].state = selectedValue;
    }
    if (fieldName === "FeeType") {
      addedPolicyTypeData[0].feeType =
        selectedValue.value !== undefined ? selectedValue.value : "";
    }
    if (fieldName === "FeeAmount") {
      addedPolicyTypeData[0].feeAmount = selectedValue;
    }
    if (fieldName === "PolicyTerm") {
      addedPolicyTypeData[0].policyTerm = selectedValue;
    }
    if (fieldName === "FeeLevel") {
      addedPolicyTypeData[0].feeLevel = selectedValue;
    }
    if (fieldName === "EffectiveDate") {
      addedPolicyTypeData[0].effectiveDate = selectedValue;
    }
    if (fieldName === "ExpirationDate") {
      addedPolicyTypeData[0].expirationDate = selectedValue;
    }
  };
  const DisablePreviousDates = (startDate) => {
    if (startDate !== "") {
      var minDate = new Date(startDate);
      minDate.setDate(minDate.getDate() + 1);
      minDate = minDate.toISOString("YYYY-MM-dd").slice(0, 10);
      setMinExpirationDate(minDate);
    } else {
      setMinExpirationDate("");
    }
  };
  var columns = [
    {
      name: (
        <div>
          Carrier <span className="text-red-500">*</span>
        </div>
      ),
      cell: (row) => {
        return (
          <SelectInput
            options={carrierOptions}
            defaultValue={selectedCarrier}
            onChange={(e) => {
              setSelectedCarrier(e);
              handleAddPolicyType("CarrierName", e !== null ? e.label : "");
              handleAddPolicyType("CarrierId", e !== null ? e.value : "");
            }}
          />
        );
      },

      sortable: true,
      grow: 2,
      width: "15%",
    },
    {
      name: (
        <div>
          State <span className="text-red-500">*</span>
        </div>
      ),
      cell: (row) => {
        return (
          <SelectInput
            options={stateOptions}
            defaultValue={selectedState}
            onChange={(e) => {
              setSelectedState(e);
              handleAddPolicyType("State", e !== null ? e.label : "");
            }}
          />
        );
      },
      sortable: true,

      width: "12%",
    },
    {
      name: (
        <div>
          Fee Type <span className="text-red-500">*</span>
        </div>
      ),
      cell: (row) => {
        return (
          <SelectInput
            placeholder="Fee Type"
            options={feeTypeData}
            defaultValue={
              feeTypeData.filter((x) => x.value === row.feeType).length === 0
                ? null
                : feeTypeData.filter((x) => x.value === row.feeType)[0]
            }
            onChange={(e) => {
              handleEditPolicyType(
                "EditPolicyType",
                "feeType",
                e != null ? e : ""
              );
              handleAddPolicyType("FeeType", e != null ? e : "");
            }}
          />
        );
      },
      sortable: true,
      width: "11%",
    },
    {
      name: (
        <div>
          Fee Amount <span className="text-red-500">*</span>
        </div>
      ),
      cell: (row) => {
        return (
          <TextInput
            placeholder="0.00"
            defaultValue=""
            onChange={(e) => {
              const re = /^[0-9\b]+$/;
              // if value is not blank, then test the regex
              if (e.target.value === "" || re.test(e.target.value)) {
                setInputFeeAmount(e.target.value);
                handleEditPolicyType(
                  "EditPolicyType",
                  "feeAmount",
                  e.target.value
                );
                handleAddPolicyType("FeeAmount", e.target.value);
              }
            }}
          />
        );
      },
      sortable: true,
      width: "11%",
    },
    {
      name: "Policy Term",

      cell: (row) => {
        return (
          <SelectInput
            options={policyTermOptions}
            defaultValue={selectedPolicyTerm}
            onChange={(e) => {
              setSelectedPolicyTerm(e);
              handleAddPolicyType("PolicyTerm", e !== null ? e.value : "");
            }}
          />
        );
      },
      sortable: true,
      width: "12%",
    },
    {
      name: "Fee Level",
      cell: (row) => {
        return (
          <SelectInput
            options={feeLevelOptions}
            defaultValue={selectedFeeLevel}
            onChange={(e) => {
              setSelectedFeeLevel(e !== null ? e.label : "");
              handleAddPolicyType("FeeLevel", e !== null ? e.label : "");
            }}
          />
        );
      },
      sortable: true,
      width: "12%",
    },
    {
      name: (
        <div>
          Effective Date <span className="text-red-500">*</span>
        </div>
      ),
      cell: (row) => {
        return (
          <div className="">
            <DateInput
              value={effectiveDate}
              onChange={(e) => {
                setEffectiveDate(e.target.value);
                handleAddPolicyType(
                  "EffectiveDate",
                  e !== null ? e.target.value : ""
                );
                DisablePreviousDates(e.target.value);
              }}
            />
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Expiration Date",
      cell: (row) => {
        return (
          <div className="">
            <DateInput
              defaultValue={expirationDate}
              onChange={(e) => {
                setExpirationDate(e.target.value);
                handleAddPolicyType(
                  "ExpirationDate",
                  e !== null ? e.target.value : ""
                );
              }}
              min={minExpirationDate}
              readOnly={minExpirationDate === "" ? true : false}
            />
          </div>
        );
      },
      sortable: true,
    },
    // {
    //   name: "Actions",
    //   sortable: true,
    //   cell: (row) =>
    //  (
    //   <div className="flex flex-row">
    //       <div className="flex 2xl:flex-row flex-col items-center space-x-2 w-full mr-2">
    //         <Button
    //           className="flex items-center shadow-md text-xs font-semibold text-white justify-center gap-x-1 rounded-full ml-auto bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70"
    //           onClickFunction={() => handleSave(row)}
    //         >
    //           <CheckCircleIcon className="h-4 w-4" />
    //           <div>Save</div>
    //         </Button>
    //         {/* <CancelButton /> */}
    //         <CancelButton
    //           className="flex items-center text-xs shadow-md font-semibold text-white justify-center gap-x-1 rounded-full bg-transparent hover:bg-octonary px-2 py-1 "
    //           onClick={() => Cancel(false)}
    //         >
    //           <XMarkIcon className="h-4 w-4" />
    //           <div>Cancel</div>
    //         </CancelButton>
    //       </div>
    //       </div>
    //     ) ,
    //   button: true,
    //   grow: 2,
    //   width: "15%",
    // },
  ];

  return (
    <div className="">
      {filter && <TableFilters />}

      <div className="mx-8 px-3 py-4 space-y-1 border-l-4 border-primary box-shadow">
        <div className="flex items-center gap-x-2 -mt-2">
          <div className="text-base text-primary font-bold whitespace-pre">
            Add New Policy Fee
          </div>
          <div className="flex justify-end space-x-2 w-full">
            <SaveButton
              className={saveDisabled ? "opacity-50" : "opacity-100"}
              buttonText={saveDisabled ? "Save" : "Save"}
              onClick={() => setSaveModal(true)}
              disabled={saveDisabled}
            />
            <CancelButton buttonText="Cancel" onClick={() => Cancel(true)} />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className="mt-2 h-1 w-full border-b-2 border-secondary "></div>
          <div className="text-xs text-secondary italic font-normal mt-2">
            <b>Note: </b> All fields with * are required to fill
          </div>
        </div>

        <div className="flex items-center justify-center space-x-2 w-full mr-2"></div>

        <TableNoBorder
          title="PolicyFee"
          columns={columns}
          data={addedPolicyTypeData}
          pagination={false}
        />
      </div>
      <div className="hidden sm:block" aria-hidden="true">
        <div className=""></div>
      </div>
      <ConfirmBoxModal
        ModalTitle="Save Policy Fee"
        qConfirmation=" Are you sure you want to save this?"
        isOpen={saveModal}
        onClose={() => setSaveModal(false)}
        onClickFunction={() => handleSave(addedPolicyTypeData)}
      />
    </div>
  );
};

export default AddPolicyFeeForm;
